import {InlineElementBuilder} from '@wix/component-protocol/builder' // eslint-disable-line wix-editor/no-internal-import
import {ELEMENTS, type ElementItem} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import {SlotDataBuilder} from '../data/builders/SlotDataBuilder'
import type {ElementBuilderData} from './ElementBuilderFactory'
import {BaseElementBuilder} from './BaseElementBuilder'

export class SlotElementBuilder extends BaseElementBuilder {
    public static readonly SLOT_TYPE = 'wixui.SlotsPlaceholder'

    private slotDataBuilder: SlotDataBuilder

    constructor(private elementData: ElementBuilderData) {
        super(elementData)

        this.slotDataBuilder = new SlotDataBuilder({
            slotId: this.elementData.pointer.id,
            selector: this.selector
        })
    }

    private getSlotData() {
        const slotData = this.slotDataBuilder.toBuilderDataItem()
        return {
            content: slotData
        }
    }

    // Slot placeholder element have strict list of properties
    // And specific data interface
    buildElement(): ElementItem {
        const builder = new InlineElementBuilder()
        const data = this.getSlotData()
        const displayName = this.getDisplayName()

        const inlineElement = builder.setSelector(this.selector).setData(data).setDisplayName(displayName).build()

        return {
            elementType: ELEMENTS.ELEMENT_TYPE.inlineElement,
            inlineElement
        }
    }
}
